export default __webpack_public_path__ + "static/media/logo_cecim-01.089f9800.svg";